

export function Loader() {
    return <span className="weui-primary-loading__dot"></span>
}